export default __webpack_public_path__ + "static/media/bull-run.64948ec4.png";